'use strict';

var dateFns = require('date-fns');

const isFollowingISODatePart = (date, base) => dateFns.differenceInCalendarDays(
  /* @__PURE__ */ new Date(`${date}T00:00:00Z`),
  /* @__PURE__ */ new Date(`${base}T00:00:00Z`)
) === 1;

exports.isFollowingISODatePart = isFollowingISODatePart;
//# sourceMappingURL=isFollowingISODatePart.cjs.map
